module.exports = __webpack_public_path__ + "img/operator.3409b2a0.svg";